module.exports = __webpack_public_path__ + "static/media/trucks-row-light.baa9f557.png";